import PropTypes from 'prop-types';
import React from 'react';
import MediaPlayerEmbed from '../MediaPlayerEmbed';
import * as S from './styled';

const PreviewVideo = ({ articleImage, previewVideo }) => {
  const showPreview = previewVideo ? (
    <S.PlayerWrapper>
      <MediaPlayerEmbed
        type="video"
        title="preview"
        id={previewVideo}
        siteName="bnnvara"
      />
    </S.PlayerWrapper>
  ) : (
    <S.ImageWrapper>
      <img src={articleImage.url} alt="Spot Preview" />
    </S.ImageWrapper>
  );
  return showPreview;
};

PreviewVideo.propTypes = {
  previewVideo: PropTypes.string.isRequired,
  articleImage: PropTypes.string.isRequired,
};

export default PreviewVideo;
